/**
 * 封装localstorge
 */

const LocalStore = {
  set(key, value) {
    if (typeof value === "object") {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
    return 1;
  },
  get(key) {
    return JSON.parse(localStorage.getItem(key));
  },
  remove(key) {
    localStorage.removeItem(key);
    return 1;
  },
  clearAll() {
    localStorage.clearAll();
  }
};

export default LocalStore;
